export default function CloseMenu() {
  return (
    <svg className="w-10 h-10" width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.1783 13.5L20 23.1782L22.3567 20.8215L11.1783 9.64319L1.62125e-05 20.8215L2.35668 23.1782L11.1783 13.5Z" fill="white"/>
      <path d="M11.1783 9.17834L2.53503 3.24249e-05L0.17836 2.3567L11.3567 13.535L22.535 2.3567L20.1784 3.24249e-05L11.1783 9.17834Z" fill="white"/>
    </svg>
  )
}
